import BaseModal from "../BaseModal";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Content from "./components/Content";

/**
 * @param {React Component} children Anything that could be used in between opening and closing tags
 * @param {Object} config The acceptable config params for the modal base
 *      @param {string} type type of the modal that could be:
 *          => error, save, cancellation, activation, deletion, suspension
 *      @param {boolean} open
 *          => if true it displays the modal
 *          => if false the modal won't be displayed
 *      @param {function} handleClose the function that will be called when the modal is closed
 *      @param {Object} buttons The buttons on the dialog box, if empty, wont be displayed
 *          => cancel: the cancel button
 *          => viewData: some modals according to the designs has this button 
 *          => Action: andy action button such as Save, Confirm, etc
 *      Each BUTTON can have following properties:
 *          @param {string} text the text on the button
 *          @param {boolean} actionFunction function for whne the button is clicked
 *          @param {boolean} secondaryButton
 *              => if true returns a button with a gray background color (like Cancel)
 *              => if false retruns a button with theme background color (like Save)
 * 
 * @returns {React Component} a Modal based on the input config params 
 */

/**
 * Sample Code
 * 
 *  const [modalConfig, setModalConfig] = useState({
 *       open: false,
 *       type: "save",
 *       handleClose: () =>
 *           setModalConfig({
 *               ...modalConfig,
 *               open: false,
 *           }),
 *       buttons: {
 *           actionButton:{
 *              text: "Confirm"
 *              actionFunction: () => aletrt('Confirming'),
 *              secondaryButton: false
 *           },
 *           viewData:{
 *              text: "View Data"
 *              actionFunction: () => aletrt('Viewing Data'),
 *              secondaryButton: false
 *           },,
 *           cancel:{
 *              text: "Cancel"
 *              actionFunction: () => aletrt('Canceling'),
 *              secondaryButton: true
 *           },
 *       }
 *   });
 * 
 *  <AppModal config={modalConfig}>
 *      THIS IS A SAMPLE MESSAGE
 *  </AppModal>
 *  
 *  <button onClick={() => setModalConfig({ ...modalConfig, open:true})}>
 *      SAVE CHNAGES?
 *  </button>                       
 */

const AppModal = ({
  children,
  config: { type, headerText, open, handleClose, buttons }
}) => {
  return (
    <BaseModal config={{ open, handleClose }}>
      <Header type={type} headerText={headerText} />
      <Content>{children}</Content>
      <Footer config={{ buttons, handleClose }} />
    </BaseModal>
  )
}

export default AppModal;
